import React from "react"
import { UserContext } from "../../../context/userContext"
import { useState, useContext, useEffect } from "react"
import { FirebaseContext } from "../../../firebase"
import _ from "lodash"
import SelectEnterprise from "./components/SelectEnterprise"
import SelectOrganization from "./components/SelectOrganization"
import SelectOrganizationFallback from "./components/SelectOrganizationFallback"
import { useQuery, gql } from "@apollo/client"

export default function SelectorContainer(props) {
  const userCtx = useContext(UserContext)
  const firebase = useContext(FirebaseContext)
  const [enterpriseList, setEnterpriseList] = useState([])
  const [organizationNames, setOrganizationNames] = useState([])
  const [fetching, setFetching] = useState(true)
  const [userStatus, setUserStatus] = useState(null)

  let flexDirection = props.flexDirection || "column"

  useEffect(() => {
    const enterpriseDocs = userCtx.session.enterprise_list

    const unsubscribeEnterprise = _.map(enterpriseDocs, (docRef) =>
      docRef.onSnapshot((docSnapshot) => {
        const enterprise = docSnapshot.data()
        const enterpriseInfo = {
          enterprise_id: docRef.id,
          enterprise_name: _.get(enterprise, "enterprise_name", ""),
          enterprise_status: _.get(enterprise, "enterprise_status", ""),
        }

        setEnterpriseList((prevList) => {
          //Remove old enterprise info from list to handle stale and/or inactive entries
          const updatedList = prevList.filter(
            (item) => item.enterprise_id !== enterpriseInfo.enterprise_id
          )
          //Add the updated enterprise info back into the list if it is still active
          if (enterpriseInfo.enterprise_status === "ACTIVE") {
            return [...updatedList, enterpriseInfo]
          }
          return updatedList
        })
      })
    )

    const organizationListRef = firebase.db
      .collection("enterprise-config")
      .doc(userCtx.session.user.enterprise_id)
      .collection("organizations")

    const unsubscribeOrganization = organizationListRef.onSnapshot(
      (snapshot) => {
        let allowedOrganizationList = []
        snapshot.docs.forEach((doc) => {
          const allowedOrganizations = userCtx.session.organization_list
          if (_.includes(allowedOrganizations, doc.id)) {
            const organization = doc.data()

            if (organization.organization_status === "ACTIVE") {
              const organizationInfo = {
                organization_id: doc.id,
                organization_name: organization.organization_name,
              }
              allowedOrganizationList.push(organizationInfo)
            }
          }
        })
        setOrganizationNames(allowedOrganizationList)
      }
    )

    setFetching(false)

    return () => {
      // Cleanup the listeners when the component unmounts or when the effect reruns
      unsubscribeEnterprise.forEach((unsubscribe) => unsubscribe())
      unsubscribeOrganization()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    userCtx.session.user.enterprise_id,
    userCtx.session.enterprise_list,
    userCtx.refreshTrigger,
  ])

  const ENTERPRISE_BY_USER_QUERY = gql`
    query UserData($staff_id: ID!) {
      getAllEnterprisesByUid(staff_id: $staff_id) {
        enterprise_id
      }
    }
  `
  const { refetch: refetchEnterprises } = useQuery(ENTERPRISE_BY_USER_QUERY, {
    variables: { staff_id: userCtx.session.user.staff_id },
    skip: true,
  })

  useEffect(() => {
    const fetchEnterpriseData = async () => {
      const { data: enterpriseData } = await refetchEnterprises()
      const firstEnterpriseId =
        enterpriseData.getAllEnterprisesByUid[0].enterprise_id

      const enterpriseIds = enterpriseData.getAllEnterprisesByUid.map(
        (enterprise) => enterprise.enterprise_id
      )

      if (!enterpriseIds.includes(userCtx.session.user.enterprise_id)) {
        userCtx.changeEnterprise(firstEnterpriseId)
      }
    }

    fetchEnterpriseData()
  }, [
    enterpriseList,
    refetchEnterprises,
    userCtx,
    userCtx.session.user.enterprise_id,
  ])

  if (enterpriseList.length === 0 || organizationNames.length === 0)
    return <SelectOrganizationFallback />

  return (
    <div style={{ display: "flex", flexDirection: flexDirection }}>
      <SelectEnterprise fetching={fetching} enterpriseList={enterpriseList} />
      <SelectOrganization
        fetching={fetching}
        organizationList={organizationNames}
      />
    </div>
  )
}
